import { type FC, type MutableRefObject, useState, useRef, useEffect } from 'react';

import { Modal } from '@vakantiesnl/components/src/atoms/Modal';
import { Typography } from '@vakantiesnl/components/src/atoms/Typography';
import { ImageSlider } from '@vakantiesnl/components/src/molecules/ImageSlider';
import { useBreakpoints } from '@vakantiesnl/components/src/utils/useBreakpoints';
import { type Nbc } from '@vakantiesnl/types';

import { useStyles } from './PictureLightBox.styles';

export type PictureLightBoxProps = {
	open: boolean;
	images: Nbc.MappedBucketImgProps[];
	onClose: VoidFunction;
	title?: string | null;
	startingIndex?: number;
};

export const PictureLightBox: FC<PictureLightBoxProps> = ({ open, title, images, onClose, startingIndex = 0 }) => {
	const { classes } = useStyles();

	const { isDesktop } = useBreakpoints();
	const [progress, setProgress] = useState(0);
	const imageSliderElem = useRef<null | HTMLDivElement>(null) as MutableRefObject<HTMLDivElement>;

	useEffect(() => {
		imageSliderElem?.current?.focus();
	}, [imageSliderElem]);

	return (
		<Modal
			LeadingComponent={
				title ? (
					<Typography variant="headingSm" as="h4">
						{title}
					</Typography>
				) : (
					<></>
				)
			}
			isIndentedModal
			title={`${progress + 1} / ${images.length}`}
			open={open}
			size="full"
			titleClassName={classes.title}
			onModalClose={onClose}
			hasCloseIcon
		>
			<div className={classes.modal}>
				<ImageSlider
					carouselRef={imageSliderElem}
					images={images}
					currentImageIndex={startingIndex}
					onChange={setProgress}
					alt={`${title} image`}
					imageSizes={isDesktop ? '70vw' : '100vw'}
					loader="Contentful"
				/>
				<Typography variant="headingSm" as="h4" className={classes.description}>
					{images[progress].title}
				</Typography>
			</div>
		</Modal>
	);
};
